const toast = {
  error: {
    DEFAULT: "An error occurred DE",
    server: "Internal server error DE",
  },
};
export default toast;
